import styled from "styled-components"

import Address from "../../components/Address"
import Center from "../../components/Center"

export const IconBar = styled(Center)`
  align-items: flex-start;
  margin-top: -45px;
  z-index: 1;
`

export const SAddress = styled(Address)`
  margin-top: 24px;
  margin-bottom: 24px;
`
